import { FormattedMessage } from '@subaio/components'

import { asContainer } from 'lib/container'

import { IconHeaderError } from 'components/Icons'
import { CenterContent, SplashScreen } from 'components/Layout'

export const container = asContainer<{}>()({
	authentication: { type: 'public' },
	Running: () => (
		<CenterContent>
			<SplashScreen
				title={<FormattedMessage id='notAuthorized.title' defaultMessage='You do not have access to this page' />}
				icon={<IconHeaderError />}
			/>
		</CenterContent>
	),
})
